"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalPrice = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)({
  root: {
    textAlign: 'right'
  },
  MuiTypographyRoot: {
    lineHeight: 1.8
  }
}, {
  name: 'TotalPrice'
});
var TotalPrice = exports.TotalPrice = function TotalPrice(_ref) {
  var totalPrice = _ref.totalPrice,
    taxNote = _ref.taxNote,
    showTopDivider = _ref.showTopDivider;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, showTopDivider && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    classes: {
      h6: classes.MuiTypographyRoot
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, totalPrice)), taxNote && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    gutterBottom: true
  }, /*#__PURE__*/_react["default"].createElement("i", null, taxNote)));
};
TotalPrice.defaultProps = {
  showTopDivider: true
};